import { render, staticRenderFns } from "./KpiTreeTable.vue?vue&type=template&id=88f761a4&scoped=true"
import script from "./KpiTreeTable.vue?vue&type=script&lang=js"
export * from "./KpiTreeTable.vue?vue&type=script&lang=js"
import style0 from "./KpiTreeTable.vue?vue&type=style&index=0&id=88f761a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f761a4",
  null
  
)

export default component.exports